import { useEffect, useMemo } from "react";
import { toast } from "react-toastify";
import { Skeleton } from "@mui/material";
import MapTableSelector from "@commons/Table/TableHeader/MapTableSelector";
import { usePage } from "@hooks/usePage";
import { useGetIndividualsStatistics } from "@services/individuals/statistics";
import Card from "../components/Card";
import MapView from "../components/MapView";
import TableView from "../components/TableView";
import ModalNewIndividual from "../components/ModalNewIndividual";
import ModalEditIndividual from "../components/ModalEditIndividual";

function IndividualsScreen() {
  const { viewMode } = usePage();
  const {
    data: statistics,
    isLoading: isLoadingStatistics,
    error: errorStatistics,
  } = useGetIndividualsStatistics();

  useEffect(() => {
    if (errorStatistics) {
      toast.error("Erro ao carregar as estatísticas de indivíduos");
    }
  }, [errorStatistics]);

  const statsCards = useMemo(() => {
    if (isLoadingStatistics || !statistics) {
      return (
        <>
          <Skeleton
            variant="rectangular"
            className="rounded-3xl w-40 h-22 sm:h-26 xl:h-30"
          />
          <Skeleton
            variant="rectangular"
            className="rounded-3xl w-40 h-22 sm:h-26 xl:h-30"
          />
        </>
      );
    }

    return (
      <>
        <Card
          title="Total de Indivíduos"
          value={statistics.individualsTotal}
          variant="cyan"
        />
        <Card
          title="Indivíduos com GPS"
          value={statistics.individualsWithGPS}
          variant="blue"
        />
      </>
    );
  }, [isLoadingStatistics, statistics]);

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap justify-center md:justify-between items-start gap-6">
        <MapTableSelector />
        <div className="flex gap-3 sm:gap-4 flex-wrap justify-center">
          {statsCards}
        </div>
      </div>

      <div className="space-y-4">
        {viewMode === "map" ? (
          <>
            <MapView />
          </>
        ) : (
          <>
            <TableView />
          </>
        )}
      </div>

      <ModalNewIndividual />
      <ModalEditIndividual />
    </div>
  );
}

export default IndividualsScreen;
